import React from "react";
import {
  MainContainer,
  Container,
  TextContainer,
  CueTextContainer,
} from "./styles";

const NewPolicyNudge = (props): any => {
  const { is_visible, policyDateText, cueText, styles } = props;

  return is_visible ? (
    <MainContainer>
      <Container>
        <TextContainer styles={styles}>
          {policyDateText}
          <span>{"19 May 2024"}</span>
        </TextContainer>
      </Container>
      <CueTextContainer>{cueText}</CueTextContainer>
    </MainContainer>
  ) : null;
};

export default NewPolicyNudge;
